import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IGoal, ISurveyQuestionItemDTO } from '../../major_explorer_interface';

export class SurveyQuestionRankController {
  item: ISurveyQuestionItemDTO;
  goals: IGoal[];
  delegateHandle: string;
  selectedGoals: IGoal[] = [];
  validationCondition = {
    isValid: () => {
      return !_4.isEmpty(this.filterSelected());
    }
  };
  constructor(private myIntakeHistoryModel: any, private ItemPresenterEnum: any, private saveItemCommand: ICommand) {}

  $onInit() {
    this.initializeGoals();
  }

  initializeGoals(): void {
    this.goals = this.item._options;
    this.delegateHandle = this.item._parent.nk;
    this.identifySelectedGoals();
  }

  save = () => {
    this.setSelectedGoals();
    this.myIntakeHistoryModel.update(this.ItemPresenterEnum.RANK.key, this.selectedGoals);
    this.saveItemCommand(this.item);
  };

  filterSelected(): IGoal[] {
    return _4.filter(this.goals, (goal: IGoal) => {
      return goal._selected;
    });
  }
  updateSelection(goal: IGoal): void {
    goal._selected = !goal._selected;
  }
  identifySelectedGoals(): void {
    _4.map(this.goals, (goal: IGoal) => {
      if (goal._action.value > 0) {
        return (goal._selected = true);
      } else {
        return (goal._selected = false);
      }
    });
  }

  setSelectedGoals(): void {
    this.selectedGoals = this.filterSelected();
    _4.each(this.goals, (goal: IGoal) => {
      goal._selected ? (this.goals[goal.id]._action.value = 1) : (this.goals[goal.id]._action.value = 0);
    });
  }
}

export class SurveyQuestionRankComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/survey_question_rank/survey_question_rank.html';
  public controller: any = SurveyQuestionRankController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    mode: '@',
    item: '='
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/survey_question_rank/survey_question_rank_controller.ts